import React from 'react';
export function Footer() {
  return <footer className="bg-white py-16 border-t border-slate-100" data-id="element-1212">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1213">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-10" data-id="element-1214">
          <div className="md:col-span-4" data-id="element-1215">
            <div className="flex items-center gap-2 mb-8" data-id="element-1216">
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center" data-id="element-1217">
                <div className="w-3 h-3 border-2 border-white rounded-full border-t-transparent transform rotate-45" data-id="element-1218"></div>
              </div>
              <span className="font-bold text-2xl tracking-tight text-slate-900" data-id="element-1219">
                openmart
              </span>
            </div>
            <p className="text-slate-500 text-lg leading-relaxed max-w-xs" data-id="element-1220">
              The premier local business data API, local business API, and
              Google Places API alternative. A powerful local business search
              API for modern data teams.
            </p>
          </div>

          <div className="md:col-span-2 md:col-start-7" data-id="element-1221">
            <h4 className="text-slate-900 font-bold text-lg mb-6" data-id="element-1222">Features</h4>
            <ul className="space-y-4" data-id="element-1223">
              <li data-id="element-1224">
                <a href="#/" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1225">
                  Local business API
                </a>
              </li>
              <li data-id="element-1226">
                <a href="#/google-maps-scraper" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1227">
                  Google Maps scraper
                </a>
              </li>
              <li data-id="element-1228">
                <a href="#/local-business-database" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1229">
                  Local business database
                </a>
              </li>
              <li data-id="element-1230">
                <a href="#/local-business-enrichment" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1231">
                  Data enrichment
                </a>
              </li>
              <li data-id="element-1232">
                <a href="#/owner-finder" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1233">
                  Local business owner finder
                </a>
              </li>
              <li data-id="element-1234">
                <a href="#/local-marketing" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1235">
                  Local marketing
                </a>
              </li>
              <li data-id="element-1236">
                <a href="#/email-sequencing" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1237">
                  Email sequencing
                </a>
              </li>
              <li data-id="element-1238">
                <a href="#/ceo-founder-contact-data" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1239">
                  CEO & founder contacts
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2" data-id="element-1240">
            <h4 className="text-slate-900 font-bold text-lg mb-6" data-id="element-1241">Databases</h4>
            <ul className="space-y-4" data-id="element-1242">
              <li data-id="element-1243">
                <a href="#/data/accounting" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1244">
                  Accounting database
                </a>
              </li>
              <li data-id="element-1245">
                <a href="#" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1246">
                  More coming soon...
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2" data-id="element-1247">
            <h4 className="text-slate-900 font-bold text-lg mb-6" data-id="element-1248">Company</h4>
            <ul className="space-y-4" data-id="element-1249">
              <li data-id="element-1250">
                <a href="#" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1251">
                  About us
                </a>
              </li>
              <li data-id="element-1252">
                <a href="#" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1253">
                  Blog
                </a>
              </li>
              <li data-id="element-1254">
                <a href="#" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1255">
                  Contact
                </a>
              </li>
              <li data-id="element-1256">
                <a href="#" className="text-slate-500 hover:text-blue-600 font-medium transition-colors" data-id="element-1257">
                  Terms of service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-1258">
          <p className="text-slate-400 font-medium" data-id="element-1259">
            © {new Date().getFullYear()} Openmart Inc. All rights reserved.
          </p>
          <div className="flex space-x-8 mt-6 md:mt-0" data-id="element-1260">
            <a href="#" className="text-slate-400 hover:text-slate-900 font-medium transition-colors" data-id="element-1261">
              Privacy policy
            </a>
            <a href="#" className="text-slate-400 hover:text-slate-900 font-medium transition-colors" data-id="element-1262">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}